import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { FlowTypes, urlMapper } from '@interfaces/models';
import { select, Store } from '@ngrx/store';
import { External } from '@store/actions';
import * as fromRootStore from '@store/index';
import { selectMultiInheritanceEstateToggle } from '@store/selectors';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable()
export class MultiTriageGuard {
  constructor(
    private globalStore: Store<fromRootStore.State>,
    private cookieService: CookieService,
    private readonly location: Location,
  ) {}

  canActivate(): Observable<boolean> {
    if (this.cookieService.get('routeGuard') === 'OFF') {
      return of(true);
    }

    return this.globalStore.pipe(
      select(selectMultiInheritanceEstateToggle),
      take(1),
      map((isMultiInheritanceEstateToggle: boolean) => {
        if (isMultiInheritanceEstateToggle) {
          const url = this.location.prepareExternalUrl(
            `/${urlMapper[FlowTypes.INHERITANCE]}/overview`,
          );
          this.globalStore.dispatch(External({ url }));
          return false;
        }
        return true;
      }),
    );
  }
}
